import Config from "../global/Config"

class DynamicExternalModuleLoader {
	/**
	 * Dynamically load CSS files
	 * @param data {object}
	 * @private
	 */

	_loadCSS(data) {
		let url = data.url
		if (!data.crossDomain) {
			url = window.location.protocol + "//" + window.location.host + Config.documentRoot + data.url
		}
		let linkTag = document.createElement("link")
		linkTag.rel = "stylesheet"
		linkTag.type = "text/css"
		linkTag.href = url
		document.getElementsByTagName("head")[0].appendChild(linkTag)
	}

	/**
	 * Dynamically load JS files
	 * @param data {object}
	 * @private
	 */
	_loadJS(data) {
		let promise = new Promise(function (resolve, reject) {
			let url = data.url
			if (!data.crossDomain) {
				url = window.location.protocol + "//" + window.location.host + Config.documentRoot + data.url
			}

			let scriptTag = document.createElement("script")
			scriptTag.src = url
			scriptTag.type = "application/javascript"
			scriptTag.onload = () => {
				if (data.loadedCallback) {
					data.loadedCallback()
				}

				resolve()
			}
			scriptTag.onerror = () => {
				reject()
			}

			document.body.appendChild(scriptTag)
		})

		this.promises.push(promise)
	}

	/**
	 * dispatch DOMContentLoaded Event
	 * @private
	 */
	_dispatchDOMContentLoadedEvent() {
		let DOMContentLoadedEvent = document.createEvent("Event")
		DOMContentLoadedEvent.initEvent("DOMContentLoaded", true, true)
		window.document.dispatchEvent(DOMContentLoadedEvent)
	}
	/**
	 * Dynamically load JS & CSS files
	 * @param condition {boolean}
	 * @param jsUrl {array}
	 * @param cssUrl {array}
	 */
	load(condition, jsUrl, cssUrl, callback = undefined) {
		this.promises = []

		if (condition) {
			if (cssUrl) {
				cssUrl.forEach((item) => {
					this._loadCSS(item)
				})
			}

			if (jsUrl) {
				jsUrl.forEach((item) => {
					this._loadJS(item)
				})
			}
		}

		Promise.all(this.promises)
			.then(() => {
				if (callback) {
					callback()
				}
				this._dispatchDOMContentLoadedEvent()
			})
			.catch(() => {
				this._dispatchDOMContentLoadedEvent()
			})
	}
}

export default new DynamicExternalModuleLoader()
